const convertObjFieldsToNumbers = (obj, fields = []) => {
  const copyObj = { ...obj };
  fields.forEach((fName) => {
    if (typeof copyObj[fName] === 'string') {
      copyObj[fName] *= 1;
    }
  });

  return copyObj;
};

export default convertObjFieldsToNumbers;
